import React from "react";  
const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 61 60"
    fill="none"
  >
    <path
      opacity="0.3"
      d="M29.302 -0.00499268L38.533 21.2005L60.3307 28.9297L39.1253 38.1607L31.396 59.9585L22.165 38.753L0.367297 31.0237L21.5728 21.7928L29.302 -0.00499268Z"
      fill="black"
    />
  </svg>
);
const JoinTheHype = () => {
  return (
  <section className="category-marquee-section overflow-hidden">
      <div className="category-marquee-wrapper">
        <ul className="category-marquee-list">

          <li className="category-item">
            <h2 className="category-title">Eyeglasses</h2>
          </li>
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Sunglasses</h2>
          </li>
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Power Sunglasses</h2>
          </li>
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Computer Glasses</h2>
          </li>

          {/* repeat for smooth scroll */}
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Eyeglasses</h2>
          </li>
          <li className="category-item">
            <h2 className="category-title">Eyeglasses</h2>
          </li>
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Sunglasses</h2>
          </li>
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Power Sunglasses</h2>
          </li>
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Computer Glasses</h2>
          </li>

          {/* repeat for smooth scroll */}
          <li className="category-divider"><StarIcon /></li>

          <li className="category-item">
            <h2 className="category-title">Eyeglasses</h2>
          </li>

        </ul>
      </div>
    </section>
  );
};

export default JoinTheHype;
